import { IridiumVar } from '@/api/userAccount';

export type IridiumServiceUiOptions = {
    usesSatelliteCredits: boolean;
    varSupportsDisablingSatelliteTelemetry: boolean;
};

export const uiOptionsPerIridiumVar: Record<IridiumVar, IridiumServiceUiOptions> = {
    cloudloop: {
        usesSatelliteCredits: true,
        varSupportsDisablingSatelliteTelemetry: true,
    },
    DoD: {
        usesSatelliteCredits: false,
        varSupportsDisablingSatelliteTelemetry: false,
    },
    cubic_i: {
        usesSatelliteCredits: false,
        varSupportsDisablingSatelliteTelemetry: false,
    },
};
